/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserAccountAlertsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetUserAccountAlertsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, binReminderEnabled: boolean, userAlerts: Array<{ __typename?: 'UserAlert', id: string, frequency: Types.UserAlertFrequency, day: Types.UserAlertDay, time: string, from?: any | null }> } | null };

export type UpdateUserAccountAlertsNestedMutationVariables = Types.Exact<{
  alertInput: Array<Types.UserAlertCreateOrUpdateInput> | Types.UserAlertCreateOrUpdateInput;
  userInput: Types.UserUpdateInput;
}>;


export type UpdateUserAccountAlertsNestedMutation = { __typename?: 'Mutation', alerts?: Array<{ __typename?: 'UserAlert', id: string } | null> | null, user?: { __typename?: 'User', id: string } | null };


export const GetUserAccountAlertsDocument = gql`
    query GetUserAccountAlerts($id: ID!) {
  user(id: $id) {
    id
    binReminderEnabled
    userAlerts {
      id
      frequency
      day
      time
      from
    }
  }
}
    `;

/**
 * __useGetUserAccountAlertsQuery__
 *
 * To run a query within a React component, call `useGetUserAccountAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAccountAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAccountAlertsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserAccountAlertsQuery(baseOptions: Apollo.QueryHookOptions<GetUserAccountAlertsQuery, GetUserAccountAlertsQueryVariables> & ({ variables: GetUserAccountAlertsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAccountAlertsQuery, GetUserAccountAlertsQueryVariables>(GetUserAccountAlertsDocument, options);
      }
export function useGetUserAccountAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAccountAlertsQuery, GetUserAccountAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAccountAlertsQuery, GetUserAccountAlertsQueryVariables>(GetUserAccountAlertsDocument, options);
        }
export function useGetUserAccountAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAccountAlertsQuery, GetUserAccountAlertsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserAccountAlertsQuery, GetUserAccountAlertsQueryVariables>(GetUserAccountAlertsDocument, options);
        }
export type GetUserAccountAlertsQueryHookResult = ReturnType<typeof useGetUserAccountAlertsQuery>;
export type GetUserAccountAlertsLazyQueryHookResult = ReturnType<typeof useGetUserAccountAlertsLazyQuery>;
export type GetUserAccountAlertsSuspenseQueryHookResult = ReturnType<typeof useGetUserAccountAlertsSuspenseQuery>;
export type GetUserAccountAlertsQueryResult = Apollo.QueryResult<GetUserAccountAlertsQuery, GetUserAccountAlertsQueryVariables>;
export const UpdateUserAccountAlertsNestedDocument = gql`
    mutation UpdateUserAccountAlertsNested($alertInput: [UserAlertCreateOrUpdateInput!]!, $userInput: UserUpdateInput!) {
  alerts: createOrUpdateUserAlerts(input: $alertInput) {
    id
  }
  user: updateUser(input: $userInput) {
    id
  }
}
    `;
export type UpdateUserAccountAlertsNestedMutationFn = Apollo.MutationFunction<UpdateUserAccountAlertsNestedMutation, UpdateUserAccountAlertsNestedMutationVariables>;

/**
 * __useUpdateUserAccountAlertsNestedMutation__
 *
 * To run a mutation, you first call `useUpdateUserAccountAlertsNestedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAccountAlertsNestedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAccountAlertsNestedMutation, { data, loading, error }] = useUpdateUserAccountAlertsNestedMutation({
 *   variables: {
 *      alertInput: // value for 'alertInput'
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useUpdateUserAccountAlertsNestedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAccountAlertsNestedMutation, UpdateUserAccountAlertsNestedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAccountAlertsNestedMutation, UpdateUserAccountAlertsNestedMutationVariables>(UpdateUserAccountAlertsNestedDocument, options);
      }
export type UpdateUserAccountAlertsNestedMutationHookResult = ReturnType<typeof useUpdateUserAccountAlertsNestedMutation>;
export type UpdateUserAccountAlertsNestedMutationResult = Apollo.MutationResult<UpdateUserAccountAlertsNestedMutation>;
export type UpdateUserAccountAlertsNestedMutationOptions = Apollo.BaseMutationOptions<UpdateUserAccountAlertsNestedMutation, UpdateUserAccountAlertsNestedMutationVariables>;